export default function (hero) {
    const title = hero.querySelector('.hero-title');

    const words = title.innerText.trim().split(/\s+/);
    title.innerText = ''

    let delay = 1

    words.forEach((w, i) => {
        delay += i === 0 ? 0 : .3

        const tWord = document.createElement('div')
        tWord.classList.add('hero-title__word');
        tWord.innerHTML = `<div class="d-inline-block" style="animation-delay: ${delay}s">${w}</div>`
        title.appendChild(tWord)
    })
}
